import { getRecords } from './baserow'

export default {
  getPeople () {
    return getRecords('People')
  },
  getPerson (slug) {
    return getRecords('People', r => r.fields.Name === slug)
  }
}
